var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 11L17 6M17 6L12 1M17 6L1 6","stroke":"currentColor","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
